import React from 'react';
import { useIncludedRelationshipContext } from 'Views/Page/Contexts/IncludedRelationshipContext';
import NextUpTabContent from 'Components/ComponentLibrary/Organisms/WhatIfClientScenarioDetails/TabContent/NextUpTabContent';

const Content = () => {
  const {
    relationshipCollection,
  } = useIncludedRelationshipContext();

  const resource = relationshipCollection.resources().head();
  if (!resource) return null;

  return (
    <NextUpTabContent resource={resource} />
  );
};

export default Content;
